module.exports = __webpack_public_path__ + "img/owl-purple-back.f64ca195.png";